import React from 'react';
import { makeStyles, Menu, MenuItem, Typography } from '@material-ui/core';
import { mapCountryToFlag } from '@klp/leverandor/utils';
import {
    COUNTRY_WITH_API_SUPPORT,
    type COUNTRY_MENU_OPTION,
} from '@klp/leverandor/types';
import i18n from '@forvalter/i18n/config';
import { getConfig } from '@klpkonsern/appconfig';

const useStyles = makeStyles((theme) => ({
    countryFlag: {
        fontSize: '1.25rem',
    },
    menuItem: {
        display: 'flex',
        gap: theme.spacing(1),
        alignItems: 'center',
    },
}));

type CountryOptionsType = Array<{
    value: COUNTRY_MENU_OPTION;
    label: string;
}>;

const countryOptions: CountryOptionsType = [
    {
        value: COUNTRY_WITH_API_SUPPORT.Norway,
        label: i18n.t('leverandor.createLeverandor.country.Norway'),
    },
    {
        value: COUNTRY_WITH_API_SUPPORT.Sweden,
        label: i18n.t('leverandor.createLeverandor.country.Sweden'),
    },
    {
        value: COUNTRY_WITH_API_SUPPORT.Denmark,
        label: i18n.t('leverandor.createLeverandor.country.Denmark'),
    },
    {
        value: COUNTRY_WITH_API_SUPPORT.UnitedKingdom,
        label: i18n.t('leverandor.createLeverandor.country.UnitedKingdom'),
    },
    getConfig('WEBAPP_LEVERANDOR_OTHER_COUNTRIES_ENABLE', false)
        ? {
              value: 'Other',
              label: i18n.t('leverandor.createLeverandor.country.Other'),
          }
        : null,
].filter(Boolean) as CountryOptionsType;

interface CountryMenuProps {
    country: COUNTRY_MENU_OPTION;
    countryMenuAnchor: HTMLElement | null;
    setCountryMenuAnchor: React.Dispatch<
        React.SetStateAction<null | HTMLElement>
    >;
    handleCountrySelect: (country: COUNTRY_MENU_OPTION) => void;
}

export const CountryMenu = ({
    country,
    countryMenuAnchor,
    setCountryMenuAnchor,
    handleCountrySelect,
}: CountryMenuProps) => {
    const classes = useStyles();

    const handleCountryMenuClose = () => {
        setCountryMenuAnchor(null);
    };

    return (
        <Menu
            anchorEl={countryMenuAnchor}
            open={Boolean(countryMenuAnchor)}
            onClose={handleCountryMenuClose}
        >
            {countryOptions.map((option) => (
                <MenuItem
                    key={option.value}
                    onClick={() => handleCountrySelect(option.value)}
                    className={classes.menuItem}
                    selected={country === option.value}
                >
                    <Typography className={classes.countryFlag}>
                        {mapCountryToFlag(option.value)}
                    </Typography>
                    <Typography>{option.label}</Typography>
                </MenuItem>
            ))}
        </Menu>
    );
};
